import httpServer from '@/api/http';
// 获取字典表
export const searchDictionaryInfo = (data) => httpServer({ url: '/scavenger/dictionary/searchDictionaryInfo' }, data);
// 登录
export const loginForH5 = (data) => {
    return httpServer(
      {
        url: "user/loginForH5",
      },
      data
    );
};
// 获取邮箱验证码 user/getEmailCode
export const getEmailCode = (data) => {
    return httpServer(
      {
        url: "user/getEmailCode",
      },
      data
    );
  };
  // 邮箱注册 user/registerUser
  export const registerUser = (data, url) => {
    return httpServer(
      {
        url: 'user/registerUser',
      },
      data
    );
  };
  // 忘记密码 user/updatePassword
  export const updatePassword = (data, url) => {
    return httpServer(
      {
        url: 'user/updatePassword',
      },
      data
    );
  };
  //  ”忘记密码“获取验证码
  export const forgetPwdEmailCode = (data, url) => {
    return httpServer(
      {
        url: 'user/forgetPwdEmailCode',
      },
      data
    );
  };
  //  ”忘记密码“检测验证码
  export const checkoutForgetPwdEmailCode = (data, url) => {
    return httpServer(
      {
        url: 'user/checkoutForgetPwdEmailCode',
      },
      data
    );
  };
//  案件列表
export const getCaseList = (data, url) => {
  return httpServer(
    {
      url: 'case/getCaseList',
    },
    data,
  );
};
